import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import { UseFormReturn } from 'react-hook-form'
import styles from './NmccInput.module.scss'

const OPTIONS = [
    {
        id: '1',
        value: 'Yes',
        label: 'Yes',
    },
    {
        id: '2',
        value: 'No',
        label: 'No',
    },
]

export const NmccInput = ({ form }: { form: UseFormReturn<DisruptionFormValues> }) => {
    return (
        <SuggestionInputTable
            options={OPTIONS}
            variant="table"
            type="text"
            transparent
            fullWidth
            className={styles.nmccInput}
            placeholder="No"
            value={form.watch('nmccInformed')}
            onChange={(value) => form.setValue('nmccInformed', value, { shouldDirty: true })}
            canTabThrough
        />
    )
}
